import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';

import SubscribeToNewsletterForm from '@/src/newsletter/presentation/components/subscribe-to-newsletter-form';

import css from './footer.css';

export function Footer() {
  const { t } = useTranslation('shared');

  return (
    <footer className={css.footer}>
      <div className={css.content}>
        <div className={css.brandContainer}>
          <Link href="/">
            <Image
              priority
              width={120}
              height={30}
              src="/assets/images/logo.svg"
              className={css.logo}
              alt={t('components.footer.logo_alt')}
            />
          </Link>

          <div className={css.socialNetworks}>
            <SocialNetworkLink
              href="https://www.instagram.com/utopic_us/"
              icon="/assets/images/instagram.svg"
            />
            <SocialNetworkLink
              href="https://www.facebook.com/utopicus"
              icon="/assets/images/facebook.svg"
            />
            <SocialNetworkLink href="https://x.com/utopic_us" icon="/assets/images/twitter.svg" />
            <SocialNetworkLink
              href="https://www.linkedin.com/company/utopic_us/?originalSubdomain=es"
              icon="/assets/images/linkedin.svg"
            />
            <SocialNetworkLink
              href="https://www.youtube.com/channel/UCyKNeB7dGQ_G0xVWIxsvd_A"
              icon="/assets/images/youtube.svg"
            />
          </div>
        </div>

        <div className={css.linksContainer}>
          <Link href="/tarifas" className={css.link}>
            {t('components.footer.rates')}
          </Link>
          <Link href="/eventos" className={css.link}>
            {t('components.footer.events')}
          </Link>
          <Link href="/partnership" className={css.link}>
            {t('components.footer.partnership')}
          </Link>
          <Link href="/contacto" className={css.link}>
            {t('components.footer.contact')}
          </Link>
        </div>

        <div className={css.separator}></div>

        <div className={css.infoContainer}>
          <div className={css.infoItem}>
            <span className={css.infoItemLabel}>
              {t('components.footer.customer_service_hours_label')}
            </span>
            <div className={css.infoItemContent}>
              {t('components.footer.customer_service_hours')}
            </div>
          </div>
          <div className={css.infoItem}>
            <span className={css.infoItemLabel}>Barcelona</span>
            <div className={css.infoItemContent}>
              <p className={css.infoItemParagraph}>(+34) 934 929 059</p>
              <p className={css.infoItemParagraph}>
                <a href="mailto:barcelona@utopicus.es" className={css.infoItemLink}>
                  barcelona@utopicus.es
                </a>
              </p>
            </div>
          </div>
          <div className={css.infoItem}>
            <span className={css.infoItemLabel}>Madrid</span>
            <div className={css.infoItemContent}>
              <p className={css.infoItemParagraph}>(+34) 911 590 510</p>
              <p className={css.infoItemParagraph}>
                <a href="mailto:madrid@utopicus.es" className={css.infoItemLink}>
                  madrid@utopicus.es
                </a>
              </p>
            </div>
          </div>
          <div className={css.newsletterInfoItem}>
            <span className={css.infoItemLabel}>{t('components.footer.newsletter')}</span>
            <div className={css.infoItemContent}>
              <SubscribeToNewsletterForm />
            </div>
          </div>
        </div>

        <div className={css.creditsContainer}>
          <span className={css.creditsParagraph}>{t('components.footer.copyright')}</span>
          <Link href="/politica-privacidad" className={css.creditsLink}>
            {t('components.footer.privacy_policy')}
          </Link>
          <Link href="/politica-cookies" className={css.creditsLink}>
            {t('components.footer.cookies_policy')}
          </Link>
          <Link href="/aviso-legal" className={css.creditsLink}>
            {t('components.footer.legal_notice')}
          </Link>
          <a
            href="https://www.inmocolonial.com/responsabilidad-social/etica-cumplimiento/canal-etico"
            className={css.creditsLink}
          >
            {t('components.footer.ethical channel')}
          </a>

          <div className={css.creditsGap}></div>

          <div className={css.creditsFamilyContainer}>
            <span className={css.creditsParagraph}>
              {t('components.footer.part_of_the_family')}
            </span>
            <Image
              src="/assets/images/logo-colonial.webp"
              alt={t('components.footer.logo_colonial_alt')}
              width={84}
              height={36}
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

function SocialNetworkLink(props: { href: string; icon: string }) {
  return (
    <a
      className={css.socialNetworkLink}
      href={props.href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Image src={props.icon} alt="social icon" width={20} height={20} />
    </a>
  );
}
